// extracted by css-extract-rspack-plugin
var _1 = "src-components-Chat-Bubbles-CopyBubble-Bubbles-module__bubble-o_7KMa";
var _2 = "src-components-Chat-Bubbles-CopyBubble-Bubbles-module__fadeInOut-XLRcze";
export { _1 as "bubble", _2 as "fadeInOut" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"bubble\":\"src-components-Chat-Bubbles-CopyBubble-Bubbles-module__bubble-o_7KMa\",\"fadeInOut\":\"src-components-Chat-Bubbles-CopyBubble-Bubbles-module__fadeInOut-XLRcze\"}";
        // 1752373455115
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  